export const cibRubygems = ["32 32","<path d='M10.411 10.531l-3.958 3.938 9.589 9.573 3.943-3.938 5.63-5.635-3.948-3.948v-0.016h-11.266zM16 0l-13.958 8v16l13.958 8 13.958-8v-16zM27.292 22.469l-11.292 6.505-11.292-6.505v-12.974l11.292-6.51 11.292 6.51z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-rubygems.js
// module id = null
// module chunks = 